import { Pressable, useWindowDimensions } from "react-native";
import React, { useEffect, useRef } from "react";
import {
  router,
  useGlobalSearchParams,
  useLocalSearchParams,
} from "expo-router";
import {
  setCheckoutPopUpRef,
  setClosetAccordians,
  setClosetModalRef,
  setLoginModalRef,
  setOutfitModalRef,
  setCountryModalRef,
  setCurrencyModalRef,
} from "appRedux/reducers/utilsSlice";
import { useDispatch, useSelector } from "react-redux";

import AsyncStorage from "@react-native-async-storage/async-storage";
import CheckoutPopUp from "./PDP/CheckoutPopUp";
import ClosetModal from "./ClosetModal";
import LoginModal from "./LoginModal";
import NewsLetterPopup from "./NewsLetterPopup";
import AppDownloadPopup from "./AppDownloadPopup";

import OutfitModal from "./OutfitModal";
import CountryModal from "./CountryModal";
import CurrencyModal from "./CurrencyModal";
import { getCart } from "appRedux/reducers/cartSlice";
import { getConfig, getCountry } from "appRedux/reducers/storedUtilsSlice";
import { getUserDetails } from "appRedux/reducers/profileSlice";
import {
  incrementWebOpenCount,
  resetAppDownloadPopupShownCount,
} from "appRedux/reducers/authSlice";
import { memo } from "react";

const InitialWrapper = (props) => {
  const userId = useSelector((state) => state.AuthReducer.userId);
  const guestUserId = useSelector(
    (state) => state.StoredutilsSlice.guestUserId
  );
  const isSubscribed = useSelector(
    (state) => state.ProfileReducer.isSubscribed
  );

  const { width, height } = useWindowDimensions();

  const local = useGlobalSearchParams()

  const dispatch = useDispatch();
  const _loginRef = useRef();
  const _closetModalRef = useRef();
  const _checkoutPopUp = useRef();
  const _outfitModalRef = useRef();
  const _newsLetterpopupRef = useRef();
  const _appDownloadPopupRef = useRef();
  const _countryModalRef = useRef();
  const _currencyModalRef = useRef();

  const isDesktop =
    width > height &&
    width / height > 1.3 &&
    height > 500 &&
    width > 1000 &&
    width / height < 2.5;

  useEffect(() => {
    if (userId) {
      dispatch(getUserDetails());
    }
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(setLoginModalRef(_loginRef));
    dispatch(setCheckoutPopUpRef(_checkoutPopUp));
    dispatch(setClosetModalRef(_closetModalRef));
    dispatch(setOutfitModalRef(_outfitModalRef));
    dispatch(setCountryModalRef(_countryModalRef));
    dispatch(setCurrencyModalRef(_currencyModalRef));
    dispatch(getConfig());
    // dispatch(getCountry()).then((res) => {
    //     dispatch(setCountries(res.payload.data.data.allCountries));
    //     dispatch(setCurrentCountry(res.payload.data.data.country));
    // });
    // dispatch(incrementWebOpenCount());
  }, []);

  useEffect(() => {
    if (userId || guestUserId) {
      dispatch(getCart());
    }
  }, [userId, guestUserId]);

  useEffect(() => {
    let active = true;
    let timer;
    (async () => {
      if (!isDesktop) {
        return;
      }
      let persist = await AsyncStorage.getItem("persist:root");
      let newsPopUpShownCount;
      let appDownloadPopupShownCount;
      let appDownloadLastClosedTime;
      let localNewsLetterSubscribed = false;
      let appDownloadPopupShown = false;
      try {
        newsPopUpShownCount =
          JSON.parse(JSON.parse(persist)?.AuthReducer)?.newsPopUpShownCount ||
          0;
      } catch (err) {
        newsPopUpShownCount = 0;
      }
      try {
        localNewsLetterSubscribed =
          JSON.parse(JSON.parse(persist)?.AuthReducer)
            ?.localNewsLetterSubscribed || false;
      } catch (err) {
        localNewsLetterSubscribed = false;
      }

      try {
        appDownloadPopupShownCount =
          JSON.parse(JSON.parse(persist)?.AuthReducer)
            ?.appDownloadPopupShownCount || 0;
        appDownloadLastClosedTime =
          JSON.parse(JSON.parse(persist)?.AuthReducer)
            ?.appDownloadLastClosedTime || null;
      } catch (err) {
        appDownloadPopupShownCount = 0;
      }
      if (appDownloadPopupShownCount >= 2) {
        if (appDownloadLastClosedTime) {
          const currentTime = new Date();
          const lastClosedTime = new Date(appDownloadLastClosedTime);
          const timeDifference = currentTime - lastClosedTime;
          const timeDifferenceInMinutes = Math.floor(timeDifference / 60000);
          if (timeDifferenceInMinutes >= 30) {
            dispatch(resetAppDownloadPopupShownCount());
            appDownloadPopupShownCount = 0;
          }
        }
      }

      if (appDownloadPopupShownCount < 2) {
        console.log(new Date(), "show app download popup - Initial");
        timer = setTimeout(() => {
          _appDownloadPopupRef?.current?.show();
          console.log(new Date(), "show app download popup - Show");
        }, 10000);
      }

      // if (active && newsPopUpShownCount < 4 && !localNewsLetterSubscribed && (!userId || isSubscribed == false)) {
      //     timer = setTimeout(() => {
      //         if (active) {
      //             _newsLetterpopupRef?.current?.show();
      //         }
      //     }, 1500);
      // }
    })();

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [isSubscribed, userId, isDesktop]);

  return (
    <Pressable
      style={{
        flex: 1,
        cursor: "auto",
      }}
      onPress={() => {
        _checkoutPopUp?.current?.hide();
        dispatch(setClosetAccordians(true));
        setTimeout(() => {
          dispatch(setClosetAccordians(false));
        }, 1000);
      }}
    >
      <>
        <script src="https://cdn.jsdelivr.net/npm/react-player/dist/ReactPlayer.standalone.js"></script>
        {props.children}
        <CheckoutPopUp ref={_checkoutPopUp} />
        <LoginModal ref={_loginRef} />
        <ClosetModal ref={_closetModalRef} />
        <OutfitModal ref={_outfitModalRef} />
        <NewsLetterPopup ref={_newsLetterpopupRef} />
        <AppDownloadPopup ref={_appDownloadPopupRef} />
        <CountryModal ref={_countryModalRef} />
        <CurrencyModal ref={_currencyModalRef} />
      </>
    </Pressable>
  );
};

export default memo(InitialWrapper);
